import React from 'react'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'
import SubNavigation from '../SubNavigation'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.bgColor ? props.bgColor : Theme.colors.bgGrey};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  padding-bottom: 40px;
`

export default ({ children, bgColor }) => (
  <PageWrapper bgColor={bgColor}>
    <SubNavigation />
    <Container>
      {children}
    </Container>
  </PageWrapper>
)
